var map = {
	"./bg-1.jpg": "3b2f",
	"./bg-2.jpg": "cb9c",
	"./bg-3.jpg": "42a3",
	"./bg-4.jpg": "7387",
	"./bg-5.jpg": "6694",
	"./bg-6.jpg": "e112"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36ba";